import React, { useRef } from 'react'
import './on-boarding-data-user.css'
import { InputHLPure, LabelHLPure, PhoneInputHLPure, LabelErrorPure, ButtonHLPure } from '../../pures'
import SvgIcon from '@material-ui/core/SvgIcon'

/**
 * @author Edgar Escobedo
 * @description Component for displaying user data during onboarding
 * @createdDate 14-10-2025
 * @param {*} param0 
 * @returns {JSX.Element} - The OnboardingDataUserView component
 */
const OnboardingDataUserView = ({
  t,
  dataUser,
  password,
  confirmPassword,
  onHandleChange,
  showErrorName,
  showErrorLastName,
  showErrorSecondLastName,
  showErrorCellphoneNumber,
  setShowErrorName,
  setShowErrorLastName,
  setShowErrorSecondLastName,
  setShowErrorCellphoneNumber,
  showErrorPassword,
  showErrorConfirmPassword,
  setShowErrorPassword,
  setShowErrorConfirmPassword,
  labelErrorName,
  labelErrorLastName,
  labelErrorSecondLastName,
  labelErrorCellphoneNumber,
  labelErrorPassword,
  labelErrorConfirmPassword,
  onHandleChangePassword,
  onHandleShowPassword,
  changePasswordShowPasswordIcon,
  setPassword,
  setConfirmPassword,
  onHandleShowPasswordConfirm,
  changePasswordShowPasswordConfirmIcon,
  handleValidateUserData
}) => {

  const lastInputRef = useRef(null)

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      lastInputRef.current.focus()
    }
  }
  return (
    <div className='onboardingDataUserView-container'>
      <LabelHLPure
        text={t('onboardingDataUserView.labels.data')}
        fontSize='18px'
      />
      <InputHLPure
        labelInput={t('profileAdministrationPrincipalView.name')}
        typeInput={'text'}
        inputActive={true}
        valueInput={dataUser.name}
        required={true}
        handleChangeInput={(e) => onHandleChange(e, 'name', 'nameValidator', setShowErrorName)}
        characterLimit={128}
        errorInput={showErrorName}
        errorInputText={labelErrorName}
      />
      <InputHLPure
        labelInput={t('profileAdministrationPrincipalView.firstLastName')}
        typeInput={'text'}
        inputActive={true}
        valueInput={dataUser.lastName}
        required={true}
        handleChangeInput={(e) => onHandleChange(e, 'lastName', 'firstLastNameValidator', setShowErrorLastName)}
        characterLimit={128}
        errorInput={showErrorLastName}
        errorInputText={labelErrorLastName}
      />
      <InputHLPure
        labelInput={t('profileAdministrationPrincipalView.secondLastName')}
        typeInput={'text'}
        inputActive={true}
        valueInput={dataUser.secondLastName}
        required={false}
        handleChangeInput={(e) => onHandleChange(e, 'secondLastName', 'secondLastNameValidator', setShowErrorSecondLastName)}
        characterLimit={128}
        errorInput={showErrorSecondLastName}
        errorInputText={labelErrorSecondLastName}
      />
      <PhoneInputHLPure
        labelInput={t('onboardingDataUserView.labels.cellphone')}
        placeholder={t('profileAdministrationPrincipalView.phone.placeholder')}
        value={dataUser.cellphoneNumber}
        onCellphoneChange={(e) => onHandleChange(e, 'cellphoneNumber', null, setShowErrorCellphoneNumber)}
        defaultCountry={'MX'}
        international={true}
        countryCallingCodeEditable={false}
      />
      {
        showErrorCellphoneNumber && (
          <LabelErrorPure label={labelErrorCellphoneNumber} />
        )
      }
      <LabelHLPure
        text={t('onboardingDataUserView.labels.password')}
        fontSize='18px'
      />
      <div className='onboardingDataUserView-password'>
        <LabelHLPure
          text={t('changePasswordView.newPassword')}
          fontSize={'14px'}
          showTooltip={true}
          titleTooltip={t('changePasswordView.tooltipTitleRecomendations')}
          descriptionTooltip={t('changePasswordView.tooltip.recomendations')}
          positionTooltip={'right'}
          informationIcon
        />
        <div>
          <div className='change-password-input-container'>
            <div className='change-password-input-wrapper'>
              <i className='fas fa-lock change-password-input-icon' />
            </div>
            <input
              placeholder={t('changePasswordView.placeholderPassword')}
              type='password'
              className='change-password-input'
              id='password'
              value={password}
              onChange={(e) => onHandleChangePassword(e, setPassword, setShowErrorPassword)}
              onKeyDown={handleKeyDown}
            />
            <div
              className={`changePasswordView-show-password-icon ${changePasswordShowPasswordIcon}`}
              onClick={onHandleShowPassword}
            >
              <SvgIcon
                className={`changePasswordView-password-icon ${changePasswordShowPasswordIcon}`}
              >
                <path d='M0 0h24v24H0V0z' fill='none' />
                <path d='M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z' />
              </SvgIcon>
            </div>
          </div>
          {
            showErrorPassword && (
              <LabelErrorPure label={labelErrorPassword} />
            )
          }
        </div>
      </div>
      <div>

        <div className='onboardingDataUserView-password'>
          <LabelHLPure
            text={t('changePasswordView.confirmNewPassword')}
            fontSize={'14px'}
            showTooltip={false}
          />
          <div className='change-password-input-container'>
            <div className='change-password-input-wrapper'>
              <i className='fas fa-lock change-password-input-icon' />
            </div>
            <input
              ref={lastInputRef}
              placeholder={t('changePasswordView.placeholderConfirmPassword')}
              type='password'
              className='change-password-input'
              id='confirmPassword'
              value={confirmPassword}
              onChange={(e) => onHandleChangePassword(e, setConfirmPassword, setShowErrorConfirmPassword)}
              onKeyDown={handleKeyDown}
            />
            <div
              className={`changePasswordView-show-password-icon ${changePasswordShowPasswordConfirmIcon}`}
              onClick={onHandleShowPasswordConfirm}
            >
              <SvgIcon
                className={`changePasswordView-password-icon ${changePasswordShowPasswordConfirmIcon}`}
              >
                <path d='M0 0h24v24H0V0z' fill='none' />
                <path d='M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z' />
              </SvgIcon>
            </div>
          </div>
        </div>
        {
          showErrorConfirmPassword && (
            <LabelErrorPure label={labelErrorConfirmPassword} />
          )
        }
      </div>

      <div className='onboardingDataUserView-btns'>
        <ButtonHLPure
          nameBtn={t('button.save')}
          primary
          onClickBtn={handleValidateUserData}
        />
      </div>
    </div>
  )
}

export { OnboardingDataUserView as default }